'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Properties = require('./Properties.js');

var _Properties2 = _interopRequireDefault(_Properties);

var _wixrestProperties = require('@wix/wixrest-properties');

var _wixrestProperties2 = _interopRequireDefault(_wixrestProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

self.addressParts = function (organization) {

    var overrideVal = _Properties2.default.get(organization.address, _wixrestProperties2.default.AddressProperties.ADDRESS_OVERRIDE, 'com.openrest');
    var _organization$address = organization.address,
        _organization$address2 = _organization$address.comment,
        comment = _organization$address2 === undefined ? '' : _organization$address2,
        formatted = _organization$address.formatted;


    if (organization.distributorId === 'food.co.il' && !overrideVal && comment) {
        return [comment];
    }

    var override = overrideVal || 'override_before';

    if (!comment && override !== 'override_replace') {
        return [formatted];
    } else if (!comment && override !== 'override_replace') {} else {
        switch (override) {
            case 'override_after':
                return [formatted, comment];
            case 'override_before':
                return [comment, formatted];
            case 'override_replace':
                return [comment];
            default:
                return [formatted];
        }
    }

    return [formatted];
};

exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/Address.js
// module id = 399
// module chunks = 0